import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Link } from "components";
import { useAnchor } from "hooks";
import { ArrowDown } from "icons";
import { Features18Content } from "types/graphql/generated";

interface Props {
  content: Features18Content;
}

const Features18: VFC<Props> = withErrorBoundary(({ content: { title, link, label } }) => {
  useAnchor("features18");

  return (
    <StyledFeatures18 className="features18 Content">
      <Link href={link} className="Features18__link">
        <div className="Features18__textContent">
          <h3 className="Features18__linkTitle Font_18_26_600 ">{title}</h3>
          <p className="Features18__linkText Font_18_26_450">{label}</p>
        </div>
        <div className="Features18__iconContainer">
          <ArrowDown className="Features18__icon" />
        </div>
      </Link>
    </StyledFeatures18>
  );
}, {});

const StyledFeatures18 = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Features18__link {
    width: unset;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.fog["20"]};
  }

  .Features18__textContent {
    display: flex;
  }

  .Features18__linkText {
    margin-left: 16px;
    text-decoration: underline;
  }

  .Features18__iconContainer {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    padding: 10px;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.fog["80"]};
    border-radius: 50%;
  }

  .Features18__icon {
    width: 12px;
    height: 12px;
    transform: rotate(-90deg);
    stroke: ${({ theme }) => theme.colors.fog["80"]};
  }

  .Features18__link:hover {
    .Features18__linkText {
      text-decoration: none;
    }

    .Features18__iconContainer {
      opacity: 0.7;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .Features18__link {
      padding: 0;
      background-color: inherit;
    }

    .Features18__textContent {
      flex-direction: column;
    }

    .Features18__iconContainer {
      display: none;
    }

    .Features18__linkText {
      margin-left: 0;
      margin-top: 8px;
    }
  }
`;

gql`
  fragment Features18Content on ComponentFeaturesFeatures18 {
    title
    link
    label
  }
`;

export { Features18 };
export type { Props as Features18Props };
